"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InsightsCustomProperties = void 0;
var InsightsCustomProperties = /** @class */ (function () {
    function InsightsCustomProperties() {
    }
    return InsightsCustomProperties;
}());
exports.InsightsCustomProperties = InsightsCustomProperties;
